module.exports = __webpack_public_path__ + "img/noimage.e3cc3d9.png";